import { Empty } from "antd";
import "./noPermissions.css";

const NoPermissionsPage = () => {
  return (
    <div id="no-permissions-page">
      <h2 style={{color: '#4d4d4d'}}>No page permissions for this user</h2>
      <Empty description={false} />
    </div>
  );
};

export default NoPermissionsPage;
